<template>
    <div class="tickets-widget">
        <div class="tickets-widget__container">
            <TicketHeader
                v-bind="ticketProps"
                @close="$emit('close')"
                @click="$emit('click')"
            />
            <div v-if="isExpanded" class="tickets-widget__card">
                <component
                    :is="summaryType"
                    v-bind="$props"
                    v-on="$listeners"
                />
                <TicketFooter
                    :canRecreate="canRecreate"
                    :isRecreatingTicket="isRecreatingTicket"
                    @recreate="$emit('recreate')"
                    @detailsClick="$emit('detailsClick')"
                />
            </div>
        </div>
    </div>
</template>

<script>
    import { TicketType } from '@core/models/tickets/enums';
    import TicketHeader from './TicketHeader';
    import TicketFooter from './TicketFooter';
    import LottoWidgetContent from './LottoWidget/LottoWidgetContent';
    import SportWidgetContent from './SportWidget/SportWidgetContent';

    export default {
        name: 'TicketsWidget',
        props: {
            isExpanded: {
                type: Boolean,
                default: false,
            },
            id: {
                type: String,
                required: true,
            },
            type: {
                type: String,
                required: true,
            },
            events: {
                type: Array,
                required: true,
            },
            // props used in children
            system: {
                type: Object,
                default: null,
            },
            stake: {
                type: Number,
                required: true,
            },
            potentialWin: {
                type: Number,
                required: true,
            },
            minimumPotentialWin: {
                type: Number,
                required: true,
            },
            payoff: {
                type: Number,
                required: true,
            },
            isWon: {
                type: Boolean,
                required: true
            },
            coefficient: {
                type: Number,
                required: true,
            },
            status: {
                type: String,
                required: true,
            },
            numEventsLeft: {
                type: Number,
                required: true
            },
            matchResults: {
                type: Array,
                default: null,
            },
            liveEvents: {
                type: Object,
                required: false,
                default() {
                    return {};
                }
            },
            hasOngoingEvents: {
                type: Boolean,
                required: false,
                default: false
            },
            // more specific prop checking inside TicketHeader
            isHighlighted: Boolean,
            canRecreate: {
                type: Boolean,
                required: true,
            },
            isRecreatingTicket: {
                type: Boolean,
                required: true,
            },
        },
        computed: {
            ticketProps() {
                const {
                    ...props
                } = this.$props;
                return props;
            },
            summaryType() {
                if (this.type === TicketType.lotto) {
                    return LottoWidgetContent;
                }
                return SportWidgetContent;
            },
        },
        components: {
            TicketHeader,
            TicketFooter,
        },
    };
</script>


// WEBPACK FOOTER //
// src/app/modules/ticketsWidget/components/TicketsWidget.vue